<main class="main">
  <section class="wrap-content">
    <div class="col-xs-4" id="mynav">
      <div class="titulo">
        <h1>Vistoria Cautelar</h1>
      </div>
      <div class="m1 menu">
        <ul id="menu-center" #menuCenter>
          <li *ngFor="let item of menuItems">
            <a (click)="scrollTo(item.link)" [class.active]="item.active">{{ item.text }}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-xs-8" style="text-align:center" id="conteud">
      <div *ngFor="let topico of topicos">
        <div [id]="'topico' + topico.id" class="ref"></div>
        <div [id]="'_topico' + topico.id">
          <ng-container *ngIf="!topico.botoes">
            <div [id]="'img' + topico.id + '_1'">
              <img [src]="topico.imagens[0]">
            </div>
          </ng-container>
          <ng-container *ngIf="topico.botoes">
            <div class="botoes">
              <a *ngFor="let botao of topico.botoes" [id]="'bt_img' + topico.id + '_' + botao.id"
                (click)="mostraImagem(topico.id, botao.id)" [class.ativo]="botao.ativo" class="bt">
                {{ botao.texto }}
              </a>
            </div>
            <div *ngFor="let img of topico.imagens; let i = index" [id]="'img' + topico.id + '_' + (i + 1)"
              [style.display]="imgAtiva[topico.id] === i + 1 ? 'block' : 'none'">
              <img [src]="img">
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </section>
</main>
